import { ILocalizable } from "infrastructure/localization";

export enum ValidationIssueSeverity {
  Warning,
  Error
}

export type ValidationTag = string | number;

export interface IValidationRule<T> {
  valid: (validateValue: T, other?: any[]) => boolean;
  result?: IValidationIssue;
}

export interface IValidation<T> {
  result?: IValidationIssue;
  rules: Array<IValidationRule<T>>;
  dependsOnFieldNames?: string[];
}

export interface IValidatable<T> {
  value: T;
  validation: IValidation<T>;
}

export interface IValidationIssue {
  severity: ValidationIssueSeverity;
  message: ILocalizable | string | undefined;
  tag?: ValidationTag;
}
